import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

interface ImportProgressProps {
  message?: string;
}

const ImportProgress = ({ message = 'Importing your cards...' }: ImportProgressProps) => {
  return (
    <div className="import-progress">
      <div className="import-progress-content">
        <FontAwesomeIcon icon={faSpinner} spin className="import-progress-spinner" />
        <h2>{message}</h2>
        <p className="import-progress-hint">This may take a moment for large collections.</p>
      </div>
      <div className="import-progress-bar">
        <div className="import-progress-bar-fill" />
      </div>
    </div>
  );
};

export default ImportProgress;
